import type { entryResource } from '@porotutu/api/features/crm/audit/resource'
import { unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { AUDIT } from '@/api/keys'
import type { Action, CrmAuditKind, CrmAuditSort } from '../vocabulary'

export type Entry = ReturnType<typeof entryResource>

export type EntryPage = { data: Entry[]; meta: ListMeta }

export type AuditListQuery = ListQuery<CrmAuditSort, never> & {
  kind?: CrmAuditKind
  action?: Action
  resource_id?: string
}

export const entriesQuery = (query: AuditListQuery) =>
  queryOptions({
    queryKey: [...AUDIT, 'list', query] as const,
    queryFn: async () => unwrap(await crm.audit.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const entryQuery = (id: string) =>
  queryOptions({
    queryKey: [...AUDIT, 'record', id] as const,
    queryFn: async () => unwrap(await crm.audit({ id }).get()),
    staleTime: Number.POSITIVE_INFINITY,
  })
